// Clients that get the MACG demo setup: static demo figures on the dashboard,
// Cleaning Excellence and Asepsis Loop, labelled with the client's own group
// and facility names (see demoFacilities.js), plus the demo top-nav links and
// the Login Access button. Add an id here to enable it.
const DEMO_CLIENT_IDS = ["5", "9"];

export const isDemoUser = () => {
  const clientId = localStorage.getItem("client-id");
  return clientId !== null && DEMO_CLIENT_IDS.includes(clientId.trim());
};

export const isDashboardDemoClient = isDemoUser;
